import { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import './resumepdf.css';
import resume from '../../assets/pdfs/Resume.pdf'

// Worker empacotado localmente
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

const options = {
  isEvalSupported: false,
};

const ResumePdf = () => {
  const [numPages, setNumPages] = useState(1);

  // CORREÇÃO: Desestruturando o objeto para pegar apenas o número
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
        <div className="pdf_container">
          <Document file={resume} onLoadSuccess={onDocumentLoadSuccess} options={options} >
            {Array.from(new Array(numPages), (el, index) => (
              // Envolvemos a página em uma div para dar um espaçamento entre a página 1 e 2
              <div key={`page_${index + 1}`} style={{ marginBottom: '15px' }}>
                <Page pageNumber={index + 1} />
              </div>
            ))}
          </Document>
      </div>
  );
}

export default ResumePdf;